import { Quill } from 'react-quill-new';

const BaseImage = (Quill as any).import('formats/image');
const Parchment = (Quill as any).import('parchment');

// Quill 2 validates every entry passed through the `formats` option against
// its registry before an editor is created. The image blot handles the actual
// width formatting below, but the format still needs a registered attributor
// so production editors can be instantiated with `width` enabled.
const ImageWidthStyle = new Parchment.StyleAttributor('width', 'width', {
  scope: Parchment.Scope.INLINE
});

class InlineImageBlot extends BaseImage {
  static create(value: string): HTMLImageElement {
    const node = super.create(value) as HTMLImageElement;
    node.style.maxWidth = '100%';
    node.style.height = 'auto';
    return node;
  }

  static formats(domNode: HTMLImageElement): any {
    const formats = super.formats(domNode);
    const width = domNode.style.width || domNode.getAttribute('width');

    if (width) {
      formats.width = width;
    }

    return formats;
  }

  format(name: string, value: any): void {
    if (name === 'width') {
      const node = this.domNode as HTMLImageElement;

      if (value) {
        node.style.width = String(value);
      } else {
        node.style.removeProperty('width');
      }

      node.removeAttribute('width');
      node.removeAttribute('height');
      node.style.maxWidth = '100%';
      node.style.height = 'auto';
      return;
    }

    super.format(name, value);
  }
}

InlineImageBlot.blotName = 'image';
InlineImageBlot.tagName = 'IMG';

Quill.register(ImageWidthStyle, true);
Quill.register({ 'formats/image': InlineImageBlot }, true);
